import { createSlice } from "@reduxjs/toolkit";
import globalCatalogManagementService from "../services/globalCatalogManagement";
import {
  addSaga,
  createAsyncSaga,
  createSagaReducer,
  persist,
  sagaSlice,
} from "./sagaStore";

const initialState: any = {
  list: {
    loading: false,
    error: null,
    data: {},
  },
  form: {
    emptyForm: true,
    preFilledForm: true,
    preFilledData: {},
    selectedSubcategoryRef: null,
    selectedCategory: null,
    dataToMigrate: {},
    taxonomy: [],
    productSpec: {},
    variantStatus: false,
  },
  shouldCallApi: true,
  isCatUp: false,
  filter: null,
  barcode: null,
  maxImagesCount: null,
  productName: null,
  isActive: null,
  subCategory: null,
  brand: null,
  category: null,
  isFilterApplied: false,
  dataSource: null,
  isGeneratedByCat: null,
  currentPage: 1,
};

const Slice: sagaSlice = createSlice({
  ...persist("globalCatalogManagement", initialState),
  reducers: {
    ...createSagaReducer("fetchTableData", "list"),
    setEmptyForm: (state, action) => {
      state.form.emptyForm = action.payload;
    },
    setPreFilledForm: (state, action) => {
      state.form.preFilledForm = action.payload;
    },
    setPreFilledData: (state, action) => {
      state.form.preFilledData = action.payload;
    },
    updateFilter(state, action) {
      state.filter = action.payload;
    },
    updateBarcode(state, action) {
      state.barcode = action.payload;
    },
    updateImageCount(state, action) {
      state.maxImagesCount = action.payload;
    },
    updateProductName(state, action) {
      state.productName = action.payload;
    },
    updateStatus(state, action) {
      state.isActive = action.payload;
    },
    updateSubCategory(state, action) {
      state.subCategory = action.payload;
    },
    updateBrand(state, action) {
      state.brand = action.payload;
    },
    updateCategory(state, action) {
      state.category = action.payload;
    },
    updateSelectedSubcategoryRef(state, action) {
      state.form.selectedSubcategoryRef = action.payload;
    },
    updateFilterButton(state, action) {
      state.isFilterApplied = action.payload;
    },
    setSelectedCategory(state, action) {
      state.form.selectedCategory = action.payload;
    },
    updateDataSource(state, action) {
      state.dataSource = action.payload;
    },
    updateShouldCallApi(state, action) {
      state.shouldCallApi = action.payload;
    },
    updateIsCatUp(state, action) {
      state.isCatUp = action.payload;
    },
    updateDataToMigrate(state, action) {
      state.form.dataToMigrate = action.payload;
    },
    updateIsGeneratedByCat(state, action) {
      state.isGeneratedByCat = action.payload;
    },
    updateTaxonomyData(state, action) {
      state.form.taxonomy = action.payload;
    },
    updateProductSpecData(state, action) {
      state.form.productSpec = action.payload;
    },
    setCurrentPage(state, action) {
      state.currentPage = action.payload;
    },
    updateVariantStatus(state, action) {
      state.form.variantStatus = action.payload;
    },
  },
});

const fetchTableDataSaga = createAsyncSaga(
  "fetchTableData",
  Slice,
  globalCatalogManagementService.fetchTableData,
  [
    "currentPage",
    "itemsPerPage",
    "emptyImagesArray",
    "barcode",
    "maxImagesCount",
    "productName",
    "isActive",
    "subCategory",
    "brand",
    "category",
    "dataSource",
    "isGeneratedByCat",
  ]
);

addSaga(Slice.actions.fetchTableData.type, fetchTableDataSaga);

export const {
  fetchTableData,
  setEmptyForm,
  setPreFilledForm,
  setPreFilledData,
  updateFilter,
  updateBarcode,
  updateImageCount,
  updateProductName,
  updateStatus,
  updateSubCategory,
  updateBrand,
  updateCategory,
  updateSelectedSubcategoryRef,
  updateFilterButton,
  setSelectedCategory,
  updateDataSource,
  updateShouldCallApi,
  updateIsCatUp,
  updateDataToMigrate,
  updateIsGeneratedByCat,
  updateTaxonomyData,
  updateProductSpecData,
  setCurrentPage,
  updateVariantStatus,
} = Slice.actions;

export default Slice.reducer;
